import { useTheme, InputAdornment, TextField } from "@mui/material"
import React, { useEffect, useRef } from "react"
import type { FormDataTypeProps } from "../../../interfaces"
import DynamicIcon from "../lib/DynamicIcon"
import type { FormDataObjectRule } from "../../../interfaces/formBuilder.interface"

const TextFieldInput: React.FC<FormDataTypeProps> = ({ onDataChange, ...props }: FormDataTypeProps) => {
  const theme = useTheme()
  const [value, setValue] = React.useState(props.value ?? null)
  const [isFormula, setIsFormula] = React.useState(false)
  const ref = useRef<HTMLDivElement>(null)

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value)
    onDataChange(props.id, e.target.value)
  }

  useEffect(() => {
    setValue(props.value)
  }, [props.value])

  useEffect(() => {
    setIsFormula(props.rules?.some((rule: FormDataObjectRule) => rule.behavior === "formula" && rule.formula) ?? false)
  }, [props.rules])

  return (
    <TextField
      ref={ref}
      value={value ?? ""}
      disabled={props.disabled || isFormula}
      sx={{ "& > .MuiInputBase-root": { backgroundColor: theme.palette.background.paper } }}
      variant="outlined"
      fullWidth
      label={props.label}
      name={props.name}
      size="small"
      placeholder={props.placeholder}
      required={props.required}
      onChange={onChange}
      helperText={props.hintText}
      InputProps={{
        readOnly: props.readOnly,
        required: props.required,
        endAdornment: (
          <InputAdornment position="end">
            <DynamicIcon name={props.type} />
          </InputAdornment>
        ),
      }}
    />
  )
}

export default TextFieldInput
